var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStandardtier(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 31,
    viewBox: "0 0 23 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 11.5,
    r: 11.5,
    fill: "#2863B6"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 21C20.799 19.0429 23 15.5203 23 11.5C23 7.47972 20.799 3.95712 17.5 2C14.201 3.95712 12 7.47972 12 11.5C12 15.5203 14.201 19.0429 17.5 21Z",
    fill: "#2FFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStandardtier);
export default __webpack_public_path__ + "static/media/standardtier.80a5eaa60ad2de2c75ceaf272d1524e7.svg";
export { ForwardRef as ReactComponent };